/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { __extends, __values } from "tslib";
import { AnnotationLayer } from "./AnnotationLayer";
import { DependencyProperty } from "igniteui-react-core";
import { Series } from "./Series";
import { FinalValueSelectionMode_$type } from "./FinalValueSelectionMode";
import { Brush } from "igniteui-react-core";
import { Thickness } from "igniteui-react-core";
import { FinalValueLayerFrame } from "./FinalValueLayerFrame";
import { List$1 } from "igniteui-react-core";
import { Axis } from "./Axis";
import { Dictionary$2 } from "igniteui-react-core";
import { Pool$1 } from "igniteui-react-core";
import { AxisAnnotation } from "./AxisAnnotation";
import { Base, enumGetBox, fromEnum, Point_$type, markType, markDep } from "igniteui-react-core";
import { AxisAnnotationFrameManager } from "./AxisAnnotationFrameManager";
import { PropertyMetadata } from "igniteui-react-core";
import { DeviceUtils } from "igniteui-react-core";
import { AnnotationLayerView } from "./AnnotationLayerView";
import { BrushUtil } from "igniteui-react-core";
/**
 * @hidden
 */
var FinalValueLayer = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(FinalValueLayer, _super);
    function FinalValueLayer() {
        var _this = _super.call(this) || this;
        _this.axisAnnotationFormatLabel = null;
        _this.th = null;
        _this.tg = null;
        var a = new FinalValueLayerFrame();
        var b = new FinalValueLayerFrame();
        var c = new FinalValueLayerFrame();
        var d = _this.hr / 1000;
        _this.qq = a;
        _this.qp = b;
        _this.qr = c;
        _this.ab = FinalValueLayer.$;
        return _this;
    }
    FinalValueLayer.prototype.get_db = function () {
        return true;
    };
    FinalValueLayer.prototype.by = function () {
        return new FinalValueLayerView(this);
    };
    FinalValueLayer.prototype.l4 = function (a) {
        _super.prototype.l4.call(this, a);
        this.tc = a;
    };
    Object.defineProperty(FinalValueLayer.prototype, "um", {
        get: function () {
            return new Thickness(1, this.tk, this.tm, this.tl, this.tj);
        },
        enumerable: false,
        configurable: true
    });
    FinalValueLayer.prototype.tf = function () {
        return this.axisAnnotationFormatLabel != null;
    };
    FinalValueLayer.prototype.r3 = function (a, b) {
        if (this.te == null || this.te == a) {
            if (!this.at.c) {
                this.mn(b);
            }
        }
    };
    FinalValueLayer.prototype.r5 = function (a, b) {
        var e_1, _a;
        var _this = this;
        _super.prototype.r5.call(this, a, b);
        var c = a;
        c.f.clear();
        c.r.clear();
        c.q.clear();
        c.ac.clear();
        c.p.clear();
        c.ab.clear();
        c.h.clear();
        c.g.clear();
        c.i.clear();
        c.k.clear();
        c.m.clear();
        c.l.clear();
        c.j.clear();
        c.n.clear();
        c.o.clear();
        c.t.clear();
        c.s.clear();
        c.u.clear();
        c.w.clear();
        c.y.clear();
        c.x.clear();
        c.v.clear();
        c.z.clear();
        c.aa.clear();
        if (this.qw(this.te)) {
            this.t3(this.te, c);
        }
        else {
            try {
                for (var _b = __values(fromEnum(this.ce.series)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var d = _c.value;
                    if (this.qw(d)) {
                        this.t3(d, c);
                    }
                    if (d.isStacked) {
                        d.lf(function (e) {
                            if (_this.qw(e)) {
                                _this.t3(e, c);
                            }
                            return true;
                        });
                    }
                }
            }
            catch (e_1_1) {
                e_1 = { error: e_1_1 };
            }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return))
                        _a.call(_b);
                }
                finally {
                    if (e_1)
                        throw e_1.error;
                }
            }
        }
    };
    FinalValueLayer.prototype.qw = function (a) {
        if (!_super.prototype.qw.call(this, a)) {
            return false;
        }
        if (this.t0 != null) {
            if (a.dx) {
                var b = a.ju();
                if (!Base.equalsStatic(this.t0, b)) {
                    return false;
                }
            }
            else {
                if (!Base.equalsStatic(this.t0, a.name)) {
                    return false;
                }
            }
        }
        return true;
    };
    FinalValueLayer.prototype.lx = function () {
        _super.prototype.lx.call(this);
        if (!this.at.c && !this.cw()) {
            return;
        }
        if (this.cw()) {
            this.t4(this.qr, false);
        }
        else {
            this.t4(this.qp, false);
        }
    };
    FinalValueLayer.prototype.ul = function (a) {
        var b = NaN;
        var c = NaN;
        var d = this.td;
        if (d == 0) {
            d = 1;
        }
        var e = false;
        if (d == 2) {
            e = true;
        }
        if (a.isVertical) {
            var f = a.as();
            if (f != null) {
                if (d == 1 || d == 2) {
                    var g = this.pz(this.b1);
                    if (f.ch) {
                        c = a.px({ $type: Point_$type, x: g.right, y: g.bottom }).y;
                    }
                    else {
                        c = a.px({ $type: Point_$type, x: g.right, y: g.top }).y;
                    }
                }
                else {
                    if (f.ch) {
                        c = 1;
                    }
                    else {
                        c = 0;
                    }
                }
            }
            return a.ps({ $type: Point_$type, x: 0, y: c }, e, true);
        }
        else {
            var h = a.as();
            if (h != null) {
                if (d == 1 || d == 2) {
                    var i = this.pz(this.b1);
                    if (h.ch) {
                        b = a.px({ $type: Point_$type, x: i.left, y: i.top }).x;
                    }
                    else {
                        b = a.px({ $type: Point_$type, x: i.right, y: i.top }).x;
                    }
                }
                else {
                    if (h.ch) {
                        b = 0;
                    }
                    else {
                        b = 1;
                    }
                }
            }
            if (a.ds) {
                return a.ps({ $type: Point_$type, x: b, y: 0 }, e, true);
            }
            else {
                return a.ps({ $type: Point_$type, x: b, y: 0 }, e, true);
            }
        }
    };
    FinalValueLayer.prototype.t3 = function (a, b) {
        var c = this.ul(a);
        var d = this.px(c);
        var e = this.o5;
        if (e == null) {
            e = this.o9;
        }
        if (e == null) {
            e = a.o5;
            if (e != null) {
                e = this.tc.b5(e);
            }
        }
        AxisAnnotationFrameManager.c(b, c, a, this.ce, this.getEffectiveViewport(), e, this.ui, this.ti, this.uk, this.uj, this.um, this.tn, this.ui, this.ti, this.uk, this.uj, this.um, this.tn, a.isVertical, !a.isVertical);
    };
    FinalValueLayer.prototype.t4 = function (a, b) {
        var c = false;
        if (this.tg == null) {
            c = true;
            this.th = new List$1(Axis.$, 0);
            this.tg = new Dictionary$2(Axis.$, Pool$1.$.specialize(AxisAnnotation.$), 0);
        }
        AxisAnnotationFrameManager.d(this, a, c, this.tg, this.th, b, this.to, this.to, this.axisAnnotationFormatLabel, this.axisAnnotationFormatLabel);
    };
    FinalValueLayer.prototype.r8 = function (a, b) {
        _super.prototype.r8.call(this, a, b);
        if (this.cw()) {
            this.t4(this.qr, true);
        }
        else {
            this.t4(this.qp, false);
        }
    };
    FinalValueLayer.prototype.ep = function () {
        return true;
    };
    FinalValueLayer.prototype.l9 = function (a, b, c, d) {
        var e_2, _a;
        _super.prototype.l9.call(this, a, b, c, d);
        switch (b) {
            case FinalValueLayer.$$p[11]:
            case FinalValueLayer.$$p[12]:
                this.mn(true);
                break;
            case FinalValueLayer.$$p[1]:
            case FinalValueLayer.$$p[0]:
            case FinalValueLayer.$$p[3]:
            case FinalValueLayer.$$p[5]:
            case FinalValueLayer.$$p[7]:
            case FinalValueLayer.$$p[6]:
            case FinalValueLayer.$$p[4]:
            case FinalValueLayer.$$p[8]:
            case FinalValueLayer.$$p[9]:
            case FinalValueLayer.$$p[10]:
                this.mn(true);
                break;
            case "SeriesViewer":
                var e = this.th;
                var f = this.tg;
                if (f != null) {
                    var _loop_1 = function (g) {
                        var h = g.value;
                        h.c(function (i) { return g.key.an.remove(i); });
                        h.clear();
                    };
                    try {
                        for (var _b = __values(fromEnum(f)), _c = _b.next(); !_c.done; _c = _b.next()) {
                            var g = _c.value;
                            _loop_1(g);
                        }
                    }
                    catch (e_2_1) {
                        e_2 = { error: e_2_1 };
                    }
                    finally {
                        try {
                            if (_c && !_c.done && (_a = _b.return))
                                _a.call(_b);
                        }
                        finally {
                            if (e_2)
                                throw e_2.error;
                        }
                    }
                    e.clear();
                    f.clear();
                }
                break;
        }
    };
    FinalValueLayer.$t = markType(FinalValueLayer, 'FinalValueLayer', AnnotationLayer.$);
    FinalValueLayer.$$p = markDep(DependencyProperty, PropertyMetadata, FinalValueLayer, 'raisePropertyChanged', ['AxisAnnotationBackgroundCornerRadius:ti:t5', [1, DeviceUtils.g(3)], 'AxisAnnotationBackground:ui:t6', [Brush.$, null], 'AxisAnnotationInterpolatedValuePrecision:to:t7', [1, -1], 'AxisAnnotationOutline:uj:t8', [Brush.$, null], 'AxisAnnotationPaddingBottom:tj:t9', [1, NaN], 'AxisAnnotationPaddingLeft:tk:ua', [1, NaN], 'AxisAnnotationPaddingRight:tl:ub', [1, NaN], 'AxisAnnotationPaddingTop:tm:uc', [1, NaN], 'AxisAnnotationStrokeThickness:tn:ud', [1, NaN], 'AxisAnnotationTextColor:uk:ue', [Brush.$, null], 'FinalValueSelectionMode:td:uf', [FinalValueSelectionMode_$type, enumGetBox(FinalValueSelectionMode_$type, 0)], 'TargetSeriesName:t0:ug', [2, null], 'TargetSeries:te:uh', [Series.$, null]]);
    return FinalValueLayer;
}(AnnotationLayer));
export { FinalValueLayer };
/**
 * @hidden
 */
var FinalValueLayerView = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(FinalValueLayerView, _super);
    function FinalValueLayerView(a) {
        var _this = _super.call(this, a) || this;
        _this.b4 = null;
        _this.b4 = a;
        return _this;
    }
    FinalValueLayerView.prototype.as = function () {
        _super.prototype.as.call(this);
    };
    FinalValueLayerView.prototype.b5 = function (a) {
        if (a == null) {
            return a;
        }
        return BrushUtil.l(a, 0.1);
    };
    FinalValueLayerView.prototype.al = function (a) {
        _super.prototype.al.call(this, a);
    };
    FinalValueLayerView.$t = markType(FinalValueLayerView, 'FinalValueLayerView', AnnotationLayerView.$);
    return FinalValueLayerView;
}(AnnotationLayerView));
export { FinalValueLayerView };
